import React from 'react';
import { NamedLink, VimeoEmbed } from '../../../components';
import { communityContentConfig } from '../../../content/communityContentConfig';
import css from './SectionInspirationCTA.module.css';

function SectionInspirationCTA() {
  const { inspirationCta } = communityContentConfig;
  const { description, resources = [], title, videos = [] } = inspirationCta;

  return (
    <section className={css.inspirationSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.inspirationCard}>
          <div className={css.inspirationContent}>
            <div className={css.inspirationIntro}>
              <h2>{title}</h2>
              <p>{description}</p>
            </div>

            {resources.length > 0 ? (
              <div className={css.resourceList}>
                {resources.map(resource => (
                  <NamedLink
                    key={resource.id}
                    name={resource.linkName}
                    className={css.resourceCard}
                  >
                    <span className={css.resourceLabel}>{resource.label}</span>
                    <span className={css.resourceDescription}>{resource.description}</span>
                  </NamedLink>
                ))}
              </div>
            ) : null}
          </div>

          <div className={css.videoList}>
            {videos.map(video => (
              <div key={video.id} className={css.videoCard}>
                <h3>{video.title}</h3>
                <VimeoEmbed className={css.video} src={video.src} title={video.title} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default SectionInspirationCTA;
